export interface FacetValueSeo {
  metaTitle: string;
  metaDescription: string;
  crawling: string;
  canonicalUrl: string;
  seoHeader?: string;
}

export interface FacetValue {
  name: string;
  featureValue: string;
  seoName: string;
  status: string;
  isHero: boolean;
  colourHex: string;
  seo?: FacetValueSeo;
}

// TODO: Rename this. The name is misleading, because this is not a list of
// FacetValues, but a dictionary
export type FacetValuesList = { [key: string]: FacetValue[] };

export interface HeroFacet extends FacetValue {
  featureMapping: string;
}

export type FacetRelation = 'AND' | 'OR';

export type FacetStatus = 'ACTIVE' | 'INACTIVE';
export type FacetSectoin = 'Opened' | 'Collapsed';

export enum FacetLayout {
  COLORS = 'Icon (colour)',
  CHECKBOXES = 'Checkboxes',
  TOGGLE = 'Toggle',
  MENU = 'Menu',
  SLIDER = 'Slider',
}

export interface Facet {
  name: string;
  seoName: string;
  featureMapping: string;
  status: FacetStatus;
  section: FacetSectoin;
  sortAlphabetically: boolean;
  layout: FacetLayout;
  searchField: boolean;
  relation: FacetRelation;
  unit: string;
  createUrlPath: boolean;
  hideInProductDetails: boolean;
  affinityRelevant: boolean;
}
